export default "__VITE_ASSET__D2L5OipU__"